import { ref } from 'vue'

const CLICKS_TO_SHUT_DOWN = 10

// Disabled by default: only enabled when explicitly set to '1'
const isShutdownByClicksEnabled = () =>
  import.meta.env.RENDERER_VITE_SHUTDOWN_BY_CLICKS_ENABLED === '1'

export const useShutdownApp = () => {
  const totalClicks = ref(0)

  const handleHeaderClick = () => {
    if (!isShutdownByClicksEnabled()) return
    totalClicks.value++
    if (totalClicks.value === CLICKS_TO_SHUT_DOWN)
      globalThis.electron.ipcRenderer.send('shutdown-app')
  }

  return { handleHeaderClick }
}
